// extracted by mini-css-extract-plugin
module.exports = {"summary":"CultivationSummary_summary_3vVks"};